import { useSlot, useStyled } from "use-styled";
import { Pressable, Text } from "react-native";

const UserPersonaCardRoot = useStyled(Pressable, {
  base: {
    className: "px-6 py-[21px] rounded-lg",
    style: {},
  },
  variants: {
    intent: {
      primary: {
        className: "bg-teachLoop-accentPrimary border-teachLoop-accentPrimary",
      },
      secondary: {
        className: "bg-teachLoop-creamDark border-teachLoop-creamDark",
      },
      tertiary: { className: "bg-teachLoop-creamLight border border-gray-200" },
    },
    disabled: {
      true: {
        className: "opacity-50",
      },
    },
  },
  defaultVariants: {},
});

const UserPersonaCardTitle = useStyled(Text, {
  base: {
    className: "font-geologica-medium font-medium text-xl leading-[1.5]",
  },
  variants: {
    intent: {
      primary: { className: "text-teachLoop-creamLight" },
      secondary: { className: "text-[#715E4F]" },
      tertiary: { className: "text-teachLoop-accentPrimary" },
    },
  },
});

const UserPersonaCardSubTitle = useStyled(Text, {
  base: {
    className:
      "font-geologica-regular font-normal text-base leading-[1.5] mt-[2.5px]",
    style: {},
  },
  variants: {
    intent: {
      primary: { className: "text-teachLoop-creamLight" },
      secondary: { className: "text-[#715E4F]" },
      tertiary: { className: "text-teachLoop-accentPrimary" },
    },
  },
  defaultVariants: {},
});

export const UserPersonaCard = useSlot(UserPersonaCardRoot, {
  Title: UserPersonaCardTitle,
  SubTitle: UserPersonaCardSubTitle,
});
